// @flow

import { isMobile } from './device'

const OPTIONS_THRESHOLD_MOBILE = 9
const OPTIONS_THRESHOLD_DESKTOP = 8

export function shouldEnableMoreOptions (optionsNo: number): boolean {
  const optionsThreshold = isMobile() ? OPTIONS_THRESHOLD_MOBILE : OPTIONS_THRESHOLD_DESKTOP
  return optionsNo > optionsThreshold
}
